import { appKey } from '@app/shared/brand'

/** Browser state renamed with the doc identifiers that read it. */
export const DOC_STORAGE_KEY_RENAMES = [
  [appKey('openDocuments'), appKey('openDocs')],
  [appKey('openDocumentsView'), appKey('openDocsView')],
  ['studio.documents.view', 'studio.docs.view'],
  [appKey('documentNavWidth'), appKey('docNavWidth')],
  [appKey('documentNavOpen'), appKey('docNavOpen')],
  [appKey('documentNavMode'), appKey('docNavMode')],
] as const

const migrated = new WeakSet<Storage>()

/** Carry each old value forward once, without replacing a value already saved under its new key. */
export function migrateDocStorage(storage?: Storage): void {
  try {
    const target = storage ?? localStorage
    if (migrated.has(target)) return
    for (const [oldKey, newKey] of DOC_STORAGE_KEY_RENAMES) {
      const oldValue = target.getItem(oldKey)
      if (oldValue === null) continue
      if (target.getItem(newKey) === null) target.setItem(newKey, oldValue)
      target.removeItem(oldKey)
    }
    migrated.add(target)
  } catch {
    /* Storage may be blocked; each reader keeps its existing in-memory fallback. */
  }
}
